import { AuthStore } from './AuthStore';
import { MainStore } from './MainStore';
import { UserStore } from './UserStore';
import { VehicleStore } from './VehicleStore';
import { DriverStore } from './DriverStore';

export class RootStore {
    authStore: AuthStore;
    mainStore: MainStore;
    userStore: UserStore;
    vehicleStore: VehicleStore;
    driverStore: DriverStore;

    constructor() {
        this.authStore = new AuthStore(this);
        this.mainStore = new MainStore(this);
        this.userStore = new UserStore(this);
        this.vehicleStore = new VehicleStore(this);
        this.driverStore = new DriverStore(this);
    }
}

export const rootStore = new RootStore();